import * as React from "react";
import type { SVGProps } from "react";
const SvgOriginalorderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="originalorder_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M277.333 234.667h8.875a106.667 106.667 0 0 0 97.792 64h213.333a106.667 106.667 0 0 0 97.792-64H704A85.333 85.333 0 0 1 789.333 320v113.792a42.667 42.667 0 1 0 85.334 0V320A170.667 170.667 0 0 0 704 149.333h-8.875a106.667 106.667 0 0 0-97.792-64H384a106.667 106.667 0 0 0-97.792 64h-8.875A170.667 170.667 0 0 0 106.667 320v469.333A170.667 170.667 0 0 0 277.333 960h128a42.667 42.667 0 1 0 0-85.333h-128A85.333 85.333 0 0 1 192 789.333V320a85.333 85.333 0 0 1 85.333-85.333zm106.667-64h213.333a21.333 21.333 0 0 1 0 42.666H384a21.333 21.333 0 0 1 0-42.666zM277.333 405.333A42.667 42.667 0 0 1 320 362.667h341.333a42.667 42.667 0 1 1 0 85.333H320a42.667 42.667 0 0 1-42.667-42.667zM320 576a42.667 42.667 0 1 0 0 85.333h64A42.667 42.667 0 1 0 384 576h-64zm366.933 0a153.6 153.6 0 1 0 0 307.2 153.6 153.6 0 0 0 0-307.2zm-230.4 153.6a230.4 230.4 0 1 1 460.8 0 230.4 230.4 0 0 1-460.8 0zm220.8-96a38.4 38.4 0 0 1 38.4 38.4v56.235l40.534 27.008a38.4 38.4 0 0 1-42.667 63.914l-57.6-38.4a38.4 38.4 0 0 1-17.067-31.957V672a38.4 38.4 0 0 1 38.4-38.4z"
    />
  </svg>
);
export default SvgOriginalorderIcon;
